import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ActivityType } from '../../activities/activities';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { Department, Skill, Procurement, Enterprise } from '../../shared-html-components/details/models';
import * as api from '../../shared/api/apihandler';
import { ActivityCategory } from 'app/shared/models/action.models';
import { ToastrService } from "ngx-toastr";
import { IdName, IdNameColors, IdNamePriority, SubscriptionObject } from 'app/shared/models/standard.models';
import { AssetCustomField } from 'app/shared/models/assets.models';


@Component({
  selector: 'app-category-setup',
  templateUrl: './category-setup.component.html',
  styleUrls: ['./category-setup.component.css']
})
export class CategorySetupComponent implements OnInit, OnDestroy {
  @ViewChild('NewItemToAdd') createTextBox!: ElementRef;
  loading = true;
  bearer = localStorage.getItem('bearer');
  data = new CategorySetupData();
  iconChanger: any;
  deletionObject: any;
  focus: any;
  channelDropDown: any;
  subscriptions = new SubscriptionObject();
  notifications: IdNamePriority | null = null;
  headers = {
    activities: { code: 'Header.Activities', sortOrder: 0, translation: '', name: 'activities' },
    channels: { code: 'Dashboard.CaseChannel', sortOrder: 1, translation: '', name: 'channels' },
    departments: { code: 'Departments.Title', sortOrder: 2, translation: '', name: 'departments' },
    offerRejections: { code: 'Offers.OfferRejections', sortOrder: 3, translation: '', name: 'offerRejections' },
    skills: { code: 'Users.Skills', sortOrder: 4, translation: '', name: 'skills' },
    offerProcurements: { code: 'Standard.ProcurementTypes', sortOrder: 5, translation: '', name: 'offerProcurements' },
    offerEnterprise: { code: 'Standard.EntrepriseTypes', sortOrder: 6, translation: '', name: 'offerEnterprise' },
    standardTexts: { code: 'Standard.StandardTexts', sortOrder: 7, translation: '', name: 'standardTexts' },
    opMainteneceCategories: { code: 'OpsAndMaintenance.Category', sortOrder: 8, translation: '', name: 'opMainteneceCategories' },
    priorities: { code: 'Standard.Priority', sortOrder: 9, translation: '', name: 'priorities' },
    caseStages: { code: 'Standard.CaseStages', sortOrder: 10, translation: '', name: 'caseStages' },
    customerTags: { code: 'Standard.CustomerTags', sortOrder: 11, translation: '', name: 'customerTags' },
    caseTags: { code: 'Standard.CaseTags', sortOrder: 11, translation: '', name: 'caseTags' },
    formChannels: { code: 'Standard.FormChannels', sortOrder: 12, translation: '', name: 'formChannels' },
    assetCategories: { code: 'Assets.AssetCategories', sortOrder: 13, translation: '', name: 'assetCategories' },
    assetModels: { code: 'Standard.AssetModels', sortOrder: 14, translation: '', name: 'assetModels' },
    assetFields: { code: 'Assets.AssetFields', sortOrder: 15, translation: '', name: 'assetFields' }
  };
  // apis

  has_GoogleMap = false;
  has_tender = JSON.parse(localStorage.getItem('guards')).find((x: { name: string }) => x.name == 'Tender') != null;
  has_ops = JSON.parse(localStorage.getItem('guards')).find((x: { name: string }) => x.name == 'OperationsAndMaintenance') != null;
  has_assets = JSON.parse(localStorage.getItem('guards')).find((x: { name: string }) => x.name == 'Assets') != null;
  model: boolean = false;
  modelType: boolean = false;
  assetModel = new AssetModels();
  assetModelType = new IdName();
  subAssetSize: number = 10;
  newHeatingModel = false;
  editHeatingModel = false;

  constructor(private httpClient: HttpClient, private sharedData: SharedDataService, private translate: TranslateService, private activeRoute: ActivatedRoute, private toastr: ToastrService,) {
    this.getIndexByTranslate();
  }

  ngOnInit() {
    this.has_GoogleMap = !!JSON.parse(localStorage.getItem('guards')).find((x: { name: string }) => x.name == 'GoogleMap')
    this.subscriptions.skills = this.sharedData.skills().subscribe((data) => { this.data.skills.list = data; this.focus = null })
    this.subscriptions['departments'] = this.sharedData.departments().subscribe((data) => {
      this.data.departments.list = data;
      this.focus = null
    })
    this.subscriptions['notificationSets'] = this.sharedData.notificationSets().subscribe((data) => this.notifications = data)
    this.getActivityTypes()
    this.checkAccess();
    this.subscriptions['queryParams'] = this.activeRoute.queryParams.subscribe((data) => {
      if (data.edit) {
        switch (data.edit) {
          case ('opsAndMaintenance'): {
            this.data.view = 'opMainteneceCategories';
            this.getDVCategories();
            break
          }
          case ('activities'): {
            this.data.view = 'activities';
            this.getActivityTypes();
            break
          }
          case 'assetFields': {
            this.data.view = 'assetFields';
            this.getAssetCustomFields();
            break
          }
          case ('channels'): {
            this.getCaseChannels();
            this.data.view = 'channels';
            break;
          }
          case ('departments'): {
            data.view = 'departments';
            break
          }
          case ('offerRejections'): {
            this.getOfferRejections();
            this.data.view = 'offerRejections';
            break
          }
          case ('skills'): {
            this.data.view = 'skills';
            break
          }
          case ('offerProcurements'): {
            this.getOfferProcurements();
            this.data.view = 'offerProcurements';
            break
          }
          case ('standardTexts'): {
            this.getStandardTexts();
            this.data.view = 'standardTexts';
            break
          }
          case ('priorities'): {
            this.getPriorities();
            this.data.view = 'priorities';
            break
          }
          case ('caseStages'): {
            this.getCaseStages();
            this.data.view = 'caseStages';
            break
          }
          case ('customerTags'): {
            this.getCustomerTags();
            this.data.view = 'customerTags';
            break
          }
          case ('formChannels'): {
            this.getFormChannels();
            this.data.view = 'formChannels';
            break
          }
          case ('assetCategories'): {
            this.getAssetCategories();
            this.data.view = 'assetCategories';
            break
          }
          case ('assetModels'): {
            this.getAssetModels();
            this.data.view = 'assetModels';
            break
          }
        }
      }
    });
    setTimeout(() => {
      this.loading = false;
    }, Math.floor(Math.random() * (1500 - 200 + 1) + 200));
  }

  ngOnDestroy(): void {
    for (let x of Object.keys(this.subscriptions)) this.subscriptions[x].unsubscribe();
  }

  async getIndexByTranslate() {
    let temp = [];
    let h = this.headers;
    for (let x of Object.keys(this.headers) as (keyof typeof h)[]) {
      this.headers[x].translation = this.translate.instant(this.headers[x].code);
      temp.push(this.headers[x])
    }
    temp = temp.sort((a,b)=> a.translation.toLowerCase() < b.translation.toLowerCase() ? -1 : 1);
    for (let i = 0; i < temp.length; i++) {
      temp[i].sortOrder = i;
      this.headers[temp[i].name as keyof typeof h] = temp[i];
    }
  }

  checkAccess() {
    this.data.activities.hide = JSON.parse(localStorage.getItem('guards')).find((x: { name: string }) => x.name == 'Activities') == null
    this.data.departments.hide = JSON.parse(localStorage.getItem('guards')).find((x: { name: string }) => x.name == 'Offer' || x.name == 'Shop') == null
    this.data.opsMaintenenceCategories.hide = JSON.parse(localStorage.getItem('guards')).find((x: { name: string }) => x.name == 'OperationsAndMaintenance') == null
  }


  //Activities
  getActivityTypes() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get<ActivityType[]>(api.jubloApi + 'api/Activity/ActivityTypes', { headers }).subscribe(
      (data: Array<ActivityType>) => { this.data.activities.list = data; }
    );
  }

  AddNewActivityType(x: ActivityType) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Activity/ActivityType', x, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.getActivityTypes(); }
    );
  }

  editActivityType(x: ActivityType) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Activity/UpdateActivity/' + x.id, x, { headers }).subscribe(
      (data) => { },
      (response) => { },
      () => { this.getActivityTypes() }
    );
  }

  deleteActivityType(x: ActivityType) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Activity/RemoveActivityType/' + x.id, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.getActivityTypes() }
    );
  }

  // AssetFields
  getAssetCustomFields() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get<AssetField[]>(api.jubloApi + 'api/Assets/GetCustomFields', { headers }).subscribe(
      (data: AssetField[]) => {
        console.log(data)
        this.data.assetFields.list = data.map(x => {
          return {
            id: x.id,
            customFieldId: x.id,
            template: !!x.template && typeof (x.template) == 'string' ? x.template.split(';') : '',
            typeId: x.type,
            fieldName: x.fieldName,
            value: null
          }
        });
      },
      (response) => console.log('Failed to get asset custom fields', response)
    );
  }

  addAssetField() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Assets/AddCustomField', this.data.assetFields.new, { headers }).subscribe({
      next: () => { this.data.assetFields.new = new NewAssetField() },
      error: err => console.error(err),
      complete: () => { this.getAssetCustomFields() }
    });
  }

  deleteAssetField(o: AssetField) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Assets/RemoveCustomField/' + o.id, { headers }).subscribe(
      (data) => this.data.assetFields.list = this.data.assetFields.list.filter(x => x.id != o.id)
    );
  }


  //Asset models and types
  getAssetModels() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get<Array<AssetModels>>(api.jubloApi + 'api/HeatingModel', { headers }).subscribe({
      next: (data) => {
        this.data.allAssetModels = data;
        for (let x of this.data.allAssetModels) {
          try {
            x.model = JSON.parse(x.name);
          }
          catch (e: any) {

          }
        }
        setTimeout(() => {
          if (!!this.data.allAssetModels && this.data.allAssetModels.length > 0) {

            let c = document.getElementById('ShowDeletedModels') as HTMLInputElement;
            if (!!c && c.checked) {
              this.data.assetModels = this.data.allAssetModels.filter((x: any) => !x.isActive);
            } else {
              this.data.assetModels = this.data.allAssetModels.filter((x: any) => x.isActive);
            }
          }
        }, 200);
      },
      error: (err) => { console.error(err); },
      complete: () => { this.getAssetModelTypes(); }
    });
  }

  getAssetModelTypes() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get<Array<IdNamePriority>>(api.jubloApi + 'api/HeatingModel/GetModelTypes', { headers }).subscribe({
      next: (data) => {
        if (!!data && data.length > 0) {
          this.data.assetModelTypes = data.filter((x: any) => x.name != 'Ingen type');
        } else {
          this.createAssetModelType('Ingen type');
        }
      },
      error: (err) => { console.error(err); },
      complete: () => { this.getAssetCategories(); }
    });
  }

  addModelOrType(type: string) {
    this.newHeatingModel = true;
    this.editHeatingModel = false;
    if (type == 'Model') {
      this.modelType = false;
      this.model = true;
      this.assetModel = new AssetModels;
    } else if (type == 'ModelType') {
      this.modelType = true;
      this.model = false;
      this.assetModelType = new IdName();
    } else {
      this.modelType = false;
      this.model = false;
    }
  }

  editModelOrType(model: any, type: string) {
    this.newHeatingModel = false;
    this.editHeatingModel = true;
    this.assetModel = new AssetModels;
    this.assetModelType = new IdName();
    if (type == 'Model') {
      this.modelType = false;
      this.model = true;
      this.assetModel = model;
    } else if (type == 'ModelType') {
      this.modelType = true;
      this.model = false;
      this.assetModelType = model;
    } else {
      this.modelType = false;
      this.model = false;
    }
  }

  modelIsActive(model: AssetModels, active: boolean) {
    let body = {
      isActive: active
    }
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.patch(api.jubloApi + 'api/HeatingModel/PatchHeatingModel/' + model.id, body, { headers }).subscribe({
      error: (err) => { console.error(err); },
      complete: () => { this.getAssetModels(); }
    });
  }

  removeModelType(type: IdName) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/HeatingModel/RemoveModelTypes/' + type.id, { headers }).subscribe({
      error: (err) => {
        if (err.status == 500) {
          console.error(err);
          this.toastr.error("Kan ikke slette en type, som bruges på en model.");
        }
      },
      complete: () => { this.getAssetModelTypes(); }
    });
  }

  createAssetModel() {
    let model = this.assetModel.category.id == '' ? null : JSON.stringify({
      categoryId: this.data.assetCategories.list.find(x => x.id == this.assetModel.category.id).id,
      categoryName: this.data.assetCategories.list.find(x => x.id == this.assetModel.category.id).name,
      modelName: this.assetModel.name,
      parents: this.assetModel.parents.length > 0 ? this.assetModel.parents : null
    });
    let name = this.assetModel.category.id == '' ? this.assetModel.model : model;
    let body = {
      name: name,
      typeId: this.assetModel.type.id,
      isActive: true
    }
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/HeatingModel/CreateHeatingModel', body, { headers }).subscribe({
      error: (err) => { console.error(err); },
      complete: () => { this.getAssetModels(); }
    });
  }

  createAssetModelType(n: string) {
    let name = n == '' ? this.assetModelType.name : n;
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/HeatingModel/AddModelTypes', { name }, { headers }).subscribe({
      error: (err) => { console.error(err); },
      complete: () => { this.getAssetModelTypes(); }
    });
  }

  editAssetModel() {
    let data = {
      name: JSON.stringify(this.assetModel.model),
      typeId: this.assetModel.type.id,
      isActive: true
    };
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.patch(api.jubloApi + 'api/HeatingModel/PatchHeatingModel/' + this.assetModel.id, data, { headers }).subscribe({
      error: (err) => { console.error(err); },
      complete: () => { this.getAssetModels(); }
    });
  }

  editAssetModelType() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.patch(api.jubloApi + 'api/HeatingModel/UpdateModelType/' + this.assetModelType.id, { name: this.assetModelType.name }, { headers }).subscribe({
      error: (err) => { console.error(err); },
      complete: () => { this.getAssetModelTypes(); }
    });
  }

  searchModels() {
    let s = document.getElementById('searchModels') as HTMLInputElement;
    if (!!s.value && s.value != '') {
      this.data.assetModels = this.data.assetModels.filter((x: any) => x.name.toLowerCase().match(s.value.toLowerCase()));
    } else {
      this.data.assetModels = this.data.allAssetModels.filter((x: any) => x.isActive);
    }
  }

  filterAllModels() {
    let c = document.getElementById('ShowDeletedModels') as HTMLInputElement;
    if (c.checked) {
      this.data.assetModels = this.data.allAssetModels.filter((x: any) => !x.isActive);
    } else {
      this.data.assetModels = this.data.allAssetModels.filter((x: any) => x.isActive);
    }

  }

  showMatchingParentModels(selectedModel: any) {
    return this.data.assetModels.filter(x => x.id != selectedModel.id);
  }

  findParentModels(model, id) {
    if (!model.parents) return false;
    return model.parents.includes(id);
  }

  //Case Channels
  getCaseChannels() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseChannels', { headers }).subscribe(
      (data: Array<ChannelItem>) => { this.data.channels.list = data.sort((a,b)=> a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);}
    );
  }

  AddNewChannel(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Website/Case/AddNewCaseChannel', x, { headers }).subscribe(
      (data) => { },
      (response) => { },
      () => { this.getCaseChannels(); }
    );
  }

  editCaseChannel(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Website/Case/EditCaseChannel/' + x.id, {
      name: x.name,
      icon: x.icon
    }, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.getCaseChannels() }
    );
  }

  deleteCaseChannel(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Website/Case/DeleteCaseChannel/' + x.id, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.getCaseChannels() }
    );
  }

  //Departments
  createDepartment(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Website/Department/Create',
      {
        "description": "string",
        "name": x.name,
        "departmentBelongToId": null
      },
      { headers }).subscribe(
        val => { },
        response => { },
        () => { this.sharedData.getDepartments() }
      );
  }

  updateDepartment(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Website/Department/Update/' + x.departmentId,
      {
        name: x.name,
        departmentBelongToId: x.departmentBelongToId,
        description: x.description,
        address: x.address,
        zipCode: x.zipCode,
        city: x.city,
        phone: x.phone,
        email: x.email,
        website: x.website,
        logo: x.logo,
        showOnMap: x.showOnMap,
        isWiser: x.isWiser,
        notificationSetId: x.notificationSetId
      },
      { headers }).subscribe(
        val => { },
        response => { },
        () => {
          this.sharedData.getDepartments()
        }
      );
  }

  deleteDepartment(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Website/Department/Delete/' + x.departmentId, { headers }).subscribe(
      val => { },
      response => { },
      () => { this.sharedData.getDepartments() }
    );
  };

  //Offer Rejections
  getOfferRejections() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Website/Offer/GetOfferRejectionAnswers', { headers }).subscribe(
      (data: Array<OfferRejection>) => { this.data.offerRejections.list = data }
    )
  }

  AddNewOfferRejection(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Website/Offer/AddOfferRejectionAnswers', x, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.getOfferRejections() }
    )
  }

  editOfferRejections(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Website/Offer/EditOfferRejectionAnswers/' + x.id, x, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('Error!', response) },
      () => { this.getOfferRejections() }
    )
  }

  deleteOfferRejections(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Website/Offer/EditOfferRejectionAnswers/' + x.id, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('Error!', response) },
      () => { this.getOfferRejections() }
    )
  }

  // Ops and Maintenence Categories

  getDVCategories() {
    this.data.opsMaintenenceCategories.new = new OpsMaintenanceCategory();
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Activity/GetDVCategory', { headers }).subscribe(
      (data: Array<ActivityCategory>) => {
        this.data.opsMaintenenceCategories.mergeNewCats(data);
        if (!this.data.opsMaintenenceCategories.tasks) {
          this.getDVAccountPlan();
        }
      },
      (response) => { },
      () => { }
    )
  }

  addDVCategory() {
    this.focus = null;
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    if (this.data.opsMaintenenceCategories.new.id == null) {
      this.httpClient.post(api.jubloApi + 'api/Activity/AddDVCategory', {
        name: this.data.opsMaintenenceCategories.new.name,
        parentId: null
      }, { headers }).subscribe(
        (data) => { },
        (response) => { },
        () => {
          //this.getDVCategories();
        }
      )
    }
    else {
      this.httpClient.put(api.jubloApi + 'api/Activity/AddDVCategory/' + this.data.opsMaintenenceCategories.new.id, {
        name: this.data.opsMaintenenceCategories.new.name,
        parentId: this.data.opsMaintenenceCategories.new.parentId
      }, { headers }).subscribe(
        (data) => { },
        (response) => { },
        () => {
          //this.getDVCategories();
        }
      )
    }
  }

  createDVFolder() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Activity/AddDVCategory', {
      name: this.data.opsMaintenenceCategories.newCat,
      parentId: this.data.opsMaintenenceCategories.focusId
    }, { headers }).subscribe(
      (data) => {
      },
      (response) => { },
      () => {
        this.getDVCategories();
        this.data.opsMaintenenceCategories.newCat = '';
      }
    )
  }

  deleteDV(id) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    if (this.data.opsMaintenenceCategories.deleteType == 'cat') {
      this.httpClient.delete(api.jubloApi + 'api/Activity/DeleteDVCategory/' + id, { headers }).subscribe(
        (data) => { },
        (response) => { },
        () => {
          this.data.opsMaintenenceCategories.list = this.data.opsMaintenenceCategories.list.filter(x => x.id != id);
          this.data.opsMaintenenceCategories.refresh();
        }
      )
    }
    else if (this.data.opsMaintenenceCategories.deleteType == 'item') {
      this.httpClient.delete(api.jubloApi + 'api/Activity/DeleteAccountPlan/' + id, { headers }).subscribe(
        (data) => { },
        (response) => { },
        () => {
          this.data.opsMaintenenceCategories.tasks = this.data.opsMaintenenceCategories.tasks.filter(x => x.id != id);
          this.data.opsMaintenenceCategories.refresh()
        }
      )
    }
  }

  getDVCategoryNameFromParentId(id) {
    if (id == null) { return '' }
    return this.data.opsMaintenenceCategories.list.find(x => x.parentId == id).name
  }

  getDVAccountPlan() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Activity/GetAccountPlans', { headers }).subscribe(
      (data: Array<OpsMaintenanceTask>) => {
        this.data.opsMaintenenceCategories.tasks = data.filter(x => x.parentId == null).map(x => {
          return {
            categoryId: x.categoryId,
            id: x.id,
            data: x,
            selected: false,
            editing: false,
            hidden: false,
            parentId: x.parentId
          }
        })
        this.data.opsMaintenenceCategories.allTasks = data.map(x => {
          return {
            categoryId: x.categoryId,
            id: x.id,
            data: x,
            selected: false,
            editing: false,
            hidden: false,
            parentId: x.parentId
          }
        });
      },
      (response) => { },
      () => { this.data.opsMaintenenceCategories.catToTree(this.data.opsMaintenenceCategories.list, this.data.opsMaintenenceCategories.tasks, false); }
    )
  }

  createDVItem() {
    console.log(this.data.opsMaintenenceCategories.newItem.data);
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    let a = this.data.opsMaintenenceCategories.newItem.data;
    a = { ...a, categoryId: this.data.opsMaintenenceCategories.focusId }
    this.httpClient.post(api.jubloApi + 'api/Activity/AddAccountPlan', a, { headers }).subscribe(
      (data) => { },
      (response) => { },
      () => {
        this.data.opsMaintenenceCategories.newItem = new OpsMaintainItem();
        this.getDVAccountPlan()
      }
    )
  }

  dvChildEvent(x: any) {
    let o = this.data.opsMaintenenceCategories;
    switch (x.type) {
      case ('catRename'): {
        this.updateDVCategory({ id: x.id, name: x.name, parentId: x.parentId })
        let a = o.list.find(y => y.id == x.id);
        a.name = x.name;
        o.refresh();
        break
      }
      case ('catDragStart'): {
        console.log(x)
        o.itemDragged = {
          type: 'category',
          id: x.id,
          parentId: x.parentId,
          name: x.name
        };
        break
      }
      case ('itemDragStart'): {
        console.log(x)
        o.itemDragged = {
          type: 'item',
          id: x.id,
          parentId: x.parentId
        };
        break
      }
      case ('itemDragEnd'):
      case ('catDragEnd'): {
        if (o.itemDragged) this.dvCatDrag(x, o); 
        break
      }
      case ('showChild'): {
        let a = o.list.find(y => y.id == x.data.id);
        a.showChildren = x.data.showChildren;
        a.showItems = x.data.showItems;
        if (a.showChildren) this.data.opsMaintenenceCategories.refocusBranch(a.id);
        break
      }
    }
  }

  dvCatDrag(x:any, o:OpsMaintenenceCategoriesContainer){
    switch (o.itemDragged.type) {
      case ('item'): {
        if (o.itemDragged != x.id) {
          let a = o.tasks.find(y => y.id == o.itemDragged.id);
          a.categoryId = x.id;
          this.updateAccountPlan(a);
          o.refresh();
        }
        ; break
      }
      case ('category'): {
        if (o.itemDragged.id != x.id) {
          this.updateDVCategory({ id: o.itemDragged.id, name: o.itemDragged.name, parentId: x.id });
          let a = o.list.find(y => y.id == o.itemDragged.id);
          a.parentId = x.id;
          o.refresh();
        }
        ; break
      }
    }
  }

  updateDVCategory(x: OpsMaintenanceCategory) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Activity/AddDVCategory/' + x.id, {
      name: x.name,
      parentId: x.parentId
    }, { headers }).subscribe(
      (data) => { },
      (response) => { },
      () => { }
    )
  }

  updateAccountPlan(x: OpsMaintainItem) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Activity/EditAccountPlan/' + x.id, {
      text: x.data.text,
      propertyCost: x.data.propertyCost,
      subscription: x.data.subscription,
      commonCost: x.data.commonCost,
      parentId: null,
      categoryId: x.categoryId
    }, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('accountPlan update failed', response) },
      () => { }
    )
  }

  // Priorities

  getPriorities() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCasePriorities', { headers }).subscribe(
      (data: Array<CasePriority>) => {
        console.log(data)
        this.data.priorities.list = data.sort((a, b) => { return a.sortOrder > b.sortOrder ? 1 : -1 });
      }
    )
  }

  addPriority() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Website/Case/CreateCasePriority', {
      name: this.data.priorities.new.name,
      sortOrder: this.data.priorities.list.length
    }, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.data.priorities.new = new CasePriority(); this.getPriorities(); }
    )
  }

  updatePriority(priority: CasePriority) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Website/Case/UpdateCasePriority', priority, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.data.priorities.new = new CasePriority(); this.getPriorities(); }
    )
  }

  deletePriority(priority: CasePriority) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Website/Case/RemoveCasePriority/' + priority.priorityId, { headers }).subscribe(
      () => { this.data.priorities.list = this.data.priorities.list.filter(x => x.priorityId != priority.priorityId) },
      (err) => { console.log('Could not delete', priority) },
      () => { }
    )
  }

  priorityHover(event) {
    if (event.id) {
      this.priorityHoverId = event ? event.id : null;
      this.priorityHoverPart = event.zone;
    }
  }

  priorityDrop(event) {
    if (this.priorityHoverId != this.priorityDragged.priorityId) {
      this.data.priorities.list.splice(this.data.priorities.list.findIndex(x => x.priorityId == this.priorityDragged.priorityId), 1); // remove dragged element from list 
      this.data.priorities.list.splice(this.data.priorities.list.findIndex(x => x.priorityId == this.priorityHoverId) + (this.priorityHoverPart == 'top' ? 0 : 1), 0, this.priorityDragged); // insert element into new position
      this.priorityOrderChanged = true;
    }
    this.priorityHoverId = null;
  }

  priorityDragEnd(event) {
    if (!this.priorityHoverId) {
      // 
    }
  }
  savePriorityOrderChange() {
    for (let i = 0; i < this.data.priorities.list.length; i++) {
      if (this.data.priorities.list[i].sortOrder != i) {
        this.data.priorities.list[i].sortOrder = i;
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        this.httpClient.put(api.jubloApi + 'api/Website/Case/UpdateCasePriority', this.data.priorities.list[i], { headers }).subscribe(
          () => { },
          () => { },
          () => { }
        )
      }
    }
    this.priorityOrderChanged = false;
  }

  priorityHoverId;
  priorityHoverPart;
  priorityDragged;
  priorityOrderChanged = false;

  //Skills
  createSkill(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/PackageDistributorSkill',
      {
        "description": x.description,
        "name": x.name,
      },
      { headers }).subscribe(
        val => { },
        response => { console.log('Error', response) },
        () => { this.sharedData.getSkills(); }
      );
  }

  updateSkill(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/PackageDistributorSkill/' + x.skillId,
      {
        "description": x.description,
        "name": x.name,
      },
      { headers }).subscribe(
        val => { },
        response => { },
        () => {
          this.sharedData.getSkills();
        }
      );
  }

  deleteSkill(x: Skill) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/PackageDistributorSkill/' + x.skillId, { headers }).subscribe(
      val => { },
      response => { },
      () => { this.sharedData.getSkills(); }
    );
  }

  //Procurements
  getOfferProcurements() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Website/Offer/GetOfferFormOfProcurement', { headers }).subscribe(
      (data: Array<OfferProcurement>) => { this.data.offerProcurements.list = data }
    )
  }

  addNewOfferProcurements(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Website/Offer/AddOfferFormOfProcurement', x, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.getOfferProcurements() }
    )
  }

  editOfferProcurements(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Website/Offer/EditOfferFormOfProcurement/' + x.id, x, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('Error!', response) },
      () => { this.getOfferProcurements() }
    )
  }

  deleteOfferProcurements(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Website/Offer/DeleteOfferFormOfProcurement/' + x.id, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('Error!', response) },
      () => { this.getOfferProcurements() }
    )
  }

  //Enterprise
  getEntrepriseTypes() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Website/Offer/GetOfferEnterpriseTypes', { headers }).subscribe(
      (data: Array<OfferEnterprise>) => { this.data.offerEnterprise.list = data }
    )
  }

  addNewEntrepriseType(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Website/Offer/AddOfferEnterpriseTypes', x, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.getEntrepriseTypes() }
    )
  }

  editEntrepriseType(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Website/Offer/EditOfferEnterpriseTypes/' + x.id, x, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('Error!', response) },
      () => { this.getEntrepriseTypes() }
    )
  }

  deleteEntrepriseType(x) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Website/Offer/DeleteOfferEnterpriseType/' + x.id, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('Error!', response) },
      () => { this.getEntrepriseTypes() }
    )
  }

  //Standard Texts
  getStandardTexts() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get<string>(api.jubloApi + 'api/CompanySettings/GetCompanySetting/' + '76efc162-03e5-4310-ae04-30c730c557b7', { headers }).subscribe({
      next: (data) => {
        if (data) {
          this.data.standardTexts.list = JSON.parse(data).texts != null ? JSON.parse(data).texts : [];
          this.data.standardTexts.textList = this.data.standardTexts.list.filter(x => x.inMessage)
          this.data.standardTexts.htmlList = this.data.standardTexts.list.filter(x => x.inOfferHTML).map(y => ({ ...y, documentSpecific: y.documentSpecific || null }));
          this.data.standardTexts.isSaving = false;
        }
      },
      error: err => console.error(err)
    });
  }

  updateStandardText() {
    this.data.standardTexts.isSaving = true;
    let saveAble = {
      categories: null, texts: null
    }
    saveAble.texts = this.data.standardTexts.textList.concat(this.data.standardTexts.htmlList);
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/CompanySettings/AddCompanySetting/' + '76efc162-03e5-4310-ae04-30c730c557b7', saveAble, { headers }).subscribe((data) => {
    }, (response) => { console.log('Error!', response) }, () => { this.getStandardTexts() })
  }

  // Stages

  getCaseStages() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseStages', { headers }).subscribe(
      (data: CaseStage[]) => {
        this.data.caseStages.list = data.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1);
      },
      (err) => { },
      () => { }
    )
  }

  addCaseStage() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Website/Case/CreateCaseStage', { ...this.data.caseStages.new, sortOrder: this.data.caseStages.list.length, probability: 0 }, { headers }).subscribe(
      (data) => { },
      (err) => { },
      () => { this.getCaseStages() }
    )
  }

  updateCaseStage(stage: CaseStage) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Website/Case/UpdateCaseStage', stage, { headers }).subscribe(
      () => { },
      () => { },
      () => { }
    )
  }

  deleteCaseStage(stage: CaseStage) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Website/Case/RemoveCaseStage/' + stage.stageId, { headers }).subscribe(
      () => { },
      () => { },
      () => { this.getCaseStages() }
    )
  }

  // CaseTags
  getCaseTags() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseTags', { headers }).subscribe(
      (data: CaseTag[]) => {
        this.data.caseTags.list = data;
        console.log(data)
      },
      () => { },
      () => { }
    )
  }

  addCaseTag(tag) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Website/Case/CreateCaseTag', tag, { headers }).subscribe({
      next: () => this.getCaseTags()
    })
  }

  updateCaseTag(tag) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Website/Case/UpdateCaseTag/' + tag.id, { name: tag.name, color: tag.color }, { headers }).subscribe({
      next: () => { }
    })
  }

  deleteCaseTag(tag){
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + `api/Website/Case/DeleteCaseTag/${tag.id}`, { headers }).subscribe({
      next:()=> this.getCaseTags()
    })
  }

  // CustomerTags

  customerTagHoverId;
  customerTagHoverPart;
  customerTagDragged;
  customerTagOrderChanged = false;

  customerTagHover(event) {
    if (event.id) {
      this.customerTagHoverId = event.id || null;
      this.customerTagHoverPart = event.zone;
    }
  }

  customerTagDrop(event) {
    if (this.customerTagHoverId != this.customerTagDragged.priorityId) {
      this.data.customerTags.list.splice(this.data.customerTags.list.findIndex(x => x.customerTagId == this.customerTagDragged.customerTagId), 1); // remove dragged element from list 
      this.data.customerTags.list.splice(this.data.customerTags.list.findIndex(x => x.customerTagId == this.customerTagHoverId) + (this.customerTagHoverPart == 'top' ? 0 : 1), 0, this.customerTagDragged); // insert element into new position
      this.customerTagOrderChanged = true;
    }
    this.customerTagHoverId = null;
  }
  customerTagDragEnd(event) {
    if (!this.customerTagHoverId) {
      // 
    }
  }
  saveCustomerTagOrderChange() {
    for (let i = 0; i < this.data.customerTags.list.length; i++) {
      if (this.data.customerTags.list[i].sortOrder != i) {
        this.data.customerTags.list[i].sortOrder = i;
        this.updateCustomerTag(this.data.customerTags.list[i]);
      }
    }
    this.customerTagOrderChanged = false;
  }
  getCustomerTags() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/IntegrationSync/GetCustomerTags', { headers }).subscribe(
      (data: CustomerTag[]) => {
        this.data.customerTags.list = data.sort((a,b)=> {
          if(!a.sortOrder) return 1;
          if(!b.sortOrder) return -1
          return +a.sortOrder < +b.sortOrder ? -1 : 1
        });
      },
      () => { },
      () => { }
    )
  }

  getFormChannels() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/ShopForm/GetChannelToForms', { headers }).subscribe(
      (data: any) => {
        this.data.formChannels.list = data;
      },
      () => { },
      () => { }
    )
    this.getCaseChannelsDropDown();
  }

  getCaseChannelsDropDown() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseChannels', { headers }).subscribe(
      (data: any) => {
        this.channelDropDown = data;
      }
    )
  }

  updateFormChannels(id, formId, channelId) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/ShopForm/AddChannelToForm',
      {
        "CaseChannelId": channelId == "null" ? null : channelId,
        "FormId": formId,
        "Id": id
      }, { headers }).subscribe(
        (data) => { },
        () => { },
        () => { this.getFormChannels(); }
      )
  }


  addCustomerTag() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/IntegrationSync/CreateCustomerTag', { ...this.data.customerTags.new, sortOrder: this.data.customerTags.list.length }, { headers }).subscribe(
      (data) => { },
      () => { },
      () => { this.getCustomerTags() }
    )
  }

  updateCustomerTag(tag: CustomerTag) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/IntegrationSync/UpdateCustomerTag', tag, { headers }).subscribe(
      (data) => { },
      (err) => { },
      () => { }
    )
  }

  deleteCustomerTag(tag: CustomerTag) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/IntegrationSync/RemoveCustomerTag/' + tag.customerTagId, { headers }).subscribe(
      (data) => { },
      (err) => { },
      () => { this.getCustomerTags() }
    )
  }

  // Asset Categories
  getAssetCategories() {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.get(api.jubloApi + 'api/Assets/AssetsCategory', { headers }).subscribe(
      (data: Array<IdNameColors>) => { this.data.assetCategories.list = data.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1) }
    )
  }

  addAssetCategory(a: IdNameColors) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Assets/CreateAssetsCategory', a, { headers }).subscribe(
      () => { },
      () => { },
      () => this.getAssetCategories()
    )
  }

  updateAssetCategory(a: IdNameColors) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.put(api.jubloApi + 'api/Assets/UpdateAssetsCategory/' + a.id, a, { headers }).subscribe(
      () => { }
    )
  }

  deleteAssetCategory(a: IdNameColors) {
    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.delete(api.jubloApi + 'api/Assets/DeleteAssetsCategory/' + a.id, { headers }).subscribe(
      () => { this.getAssetCategories() }
    )
  }

  //Shared
  contentCreate(x: string, tweak: any) {
    if (x != '') {
      switch (this.data.view) {
        case ('activities'): {
          let object = new ActivityType();
          object.name = x;
          this.AddNewActivityType(object);
          break;
        }
        case 'assetFields': {
          this.data.assetFields.new.fieldName = x;
          this.addAssetField();
          break;
        }
        case ('channels'): {
          let object = new ChannelItem();
          object.name = x;
          this.AddNewChannel(object);
          break;
        }
        case ('departments'): {
          let object = new Department()
          object.name = x;
          this.createDepartment(object);
          break;
        }
        case ('offerRejections'): {
          let object = new OfferRejection();
          object.text = x;
          this.AddNewOfferRejection(object);
          break;
        }
        case ('skills'): {
          let object = new Skill();
          object.name = x;
          this.createSkill(object);
          break;
        }
        case ('offerProcurements'): {
          let object = new Procurement();
          object.name = x;
          this.addNewOfferProcurements(object);
          break;
        }
        case ('offerEnterprise'): {
          let object = new Enterprise();
          object.name = x;
          this.addNewEntrepriseType(object);
          break;
        }
        case ('standardTexts'): {
          let object = new StandardText();
          object.header = x;
          if (!!tweak && tweak == 'html') {
            object.inOfferHTML = true;
            object.inMessage = false;
            this.data.standardTexts.htmlList.push(object);
            this.updateStandardText();
          } else {
            object.content = x;
            object.inOfferHTML = false;
            object.inMessage = true;
            this.data.standardTexts.textList.push(object);
            this.updateStandardText();
          }
          break;
        }
        case ('opMainteneceCategories'): {
          this.data.opsMaintenenceCategories.new.name = x;
          this.addDVCategory();
          break;
        }
        case ('priorities'): {
          this.data.priorities.new.name = x;
          this.addPriority();
          break;
        }
        case ('caseStages'): {
          this.data.caseStages.new.name = x;
          this.addCaseStage();
          break;
        }
        case ('customerTags'): {
          this.data.customerTags.new.name = x;
          this.addCustomerTag();
          break;
        }
        case 'caseTags': {
          this.data.caseTags.new.name = x;
          this.data.caseTags.new.color = 'skyblue';
          this.addCaseTag(this.data.caseTags.new)
          break;
        }
        case ('assetCategories'): {
          let object = new IdNameColors();
          object.name = x;
          this.addAssetCategory(object);
          break;
        }
      }
    }
    this.createTextBox.nativeElement.value = '';
  }

  updateShowOnAssetSite(object) {
    //console.log(object);
    if (!!object.template && object.template.includes('showOnAssetSite') && !object.showOnAssetSite) {
      object.template = object.template.replace('showOnAssetSite', '').replace('showOnAssetSite', '');
    } else if (object.showOnAssetSite) {
      object.template = object.template ? object.template + 'showOnAssetSite' : 'showOnAssetSite';
    } else {
      object.template = object.template.replace('showOnAssetSite', '').replace('showOnAssetSite', '');
    }

    const headers = new HttpHeaders({ 'Authorization': this.bearer });
    this.httpClient.post(api.jubloApi + 'api/Assets/UpdateCustomField/' + object.id, { template: object.template }, { headers }).subscribe({
      next: (data) => { console.log(data); },
      error: (err) => { console.error(err) }
    })
  }

  contentEdit(object) {
    switch (this.data.view) {
      case ('activities'): { this.editActivityType(object); break }
      case ('channels'): { this.editCaseChannel(object); break }
      case ('departments'): { this.updateDepartment(object); break }
      case ('offerRejections'): { this.editOfferRejections(object); break }
      case ('skills'): { this.updateSkill(object); break }
      case ('offerProcurements'): { this.editOfferProcurements(object); break }
      case ('offerEnterprise'): { this.editEntrepriseType(object); break }
      case ('standardTexts'): { this.updateStandardText(); break }
      case ('opMainteneceCategories'): {
        this.data.opsMaintenenceCategories.new = object;
        this.addDVCategory();
        break
      }
      case ('priorities'): {
        this.updatePriority(object);
        break
      }
      case ('customerTags'): { this.updateCustomerTag(object); break }
      case 'caseTags': { this.updateCaseTag(object); break }
      case ('caseStages'): { this.updateCaseStage(object); break }
      case ('assetCategories'): { this.updateAssetCategory(object); break }
    }
  }

  deleter(object) {
    switch (this.data.view) {
      case ('activities'): { this.deleteActivityType(object); break }
      case ('assetFields'): { this.deleteAssetField(object); break }
      case ('channels'): { this.deleteCaseChannel(object); break }
      case ('departments'): { this.deleteDepartment(object); break }
      case ('offerRejections'): { this.deleteOfferRejections(object); break }
      case ('skills'): { this.deleteSkill(object); break }
      case ('offerProcurements'): { this.deleteOfferProcurements(object); break }
      case ('offerEnterprise'): { this.deleteEntrepriseType(object); break }
      case ('standardTexts'): {
        switch (this.data.standardTexts.toBeDeletedType) {
          case ('text'): {
            this.data.standardTexts.textList.splice(this.data.standardTexts.toBeDeletedIndex, 1);
            this.updateStandardText();
            ; break
          }
          case ('html'): {
            this.data.standardTexts.htmlList.splice(this.data.standardTexts.toBeDeletedIndex, 1);
            this.updateStandardText();
            ; break
          }
        }
        break
      }
      case ('opMainteneceCategories'): {
        this.deleteDV(object.id);
        break
      }
      case ('priorities'): { this.deletePriority(object); break }
      case 'caseTags': { this.deleteCaseTag(object); break }
      case ('customerTags'): { this.deleteCustomerTag(object); break }
      case ('caseStages'): { this.deleteCaseStage(object); break }
      case ('assetCategories'): { this.deleteAssetCategory(object); break }
    }
  }

  objectHoverId;
  objectHoverPart;
  objectDragged;
  objectOrderChanged = false;

  objectHover(event) {
    if (event?.id) {
      this.objectHoverId = event.id || null;
      this.objectHoverPart = event.zone;
    }
  }

  objectDropped(event) {
    if(this.data.view == 'caseStages') {
        if (this.objectHoverId != this.objectDragged.stageId) {
          this.data.caseStages.list.splice(this.data.caseStages.list.findIndex(x => x.stageId == this.objectDragged.stageId), 1);
          this.data.caseStages.list.splice(this.data.caseStages.list.findIndex(x => x.stageId == this.objectHoverId) + (this.objectHoverPart == 'top' ? 0 : 1), 0, this.objectDragged);
          this.objectOrderChanged = true;
        }
        this.objectHoverId = null;
      }
  }

  saveOrderChange() {
    if(this.data.view == 'caseStages') {
        for (let i = 0; i < this.data.caseStages.list.length; i++) {
          if (this.data.caseStages.list[i].sortOrder != i) {
            this.data.caseStages.list[i].sortOrder = i;
            this.updateCaseStage(this.data.caseStages.list[i]);
          }
        }
      }
      this.objectOrderChanged = false;
    }
}

export class CategorySetupData {
  activities: ActivityTypeContainer = new ActivityTypeContainer();
  assetFields: AssetFieldsContainer = new AssetFieldsContainer();
  caseTags: CaseTagsContainer = new CaseTagsContainer();
  channels: ChannelContainer = new ChannelContainer();
  departments: DepartmentsContainer = new DepartmentsContainer();
  opsMaintenenceCategories: OpsMaintenenceCategoriesContainer = new OpsMaintenenceCategoriesContainer();
  offerRejections: OfferRejectionContainer = new OfferRejectionContainer();
  offerProcurements: OfferProcurementContainer = new OfferProcurementContainer();
  offerEnterprise: OfferEnterpriseContainer = new OfferEnterpriseContainer();
  priorities: CasePrioritiesContainer = new CasePrioritiesContainer();
  skills: SkillsContainer = new SkillsContainer();
  standardTexts: StandardTextsContainer = new StandardTextsContainer();
  caseStages: CaseStageContainer = new CaseStageContainer();
  customerTags: CustomerTagsContainer = new CustomerTagsContainer();
  formChannels: FormChannelContainer = new FormChannelContainer();
  assetCategories: AssetCategoriesContainer = new AssetCategoriesContainer();
  assetModels: Array<AssetModels> = new Array<AssetModels>();
  allAssetModels: Array<AssetModels> = new Array<AssetModels>();
  assetModelTypes: Array<IdName> = new Array<IdName>();
  view: 'activities' | 'channels' | 'departments' | 'offerRejections' | 'skills' | 'offerProcurements' | 'offerEnterprise' | 'standardTexts' | 'opMainteneceCategories' | 'priorities' | 'caseStages' | 'customerTags' | 'caseTags' | 'formChannels' | 'assetCategories' | 'assetFields' | 'assetModels' | '' = '';
}

class IdNameContainer {
  list: IdName[] = [];
  new: IdName = new IdName();
}

class AssetFieldsContainer {
  list: AssetCustomField[];
  new: NewAssetField = new NewAssetField();
}

/**
 * Only for Assets/GetCustomFields
 */
export class AssetField {
  id: string;
  fieldName: string;
  type: string;
  template: string;
}

class NewAssetField {
  fieldName: string;
  typeId: string = 'ff07e38b-1905-479f-836f-1e648bc14e54';
  template;
}

export class ChannelContainer {
  list: Array<ChannelItem>;
  new: ChannelItem = new ChannelItem();
}

export class ChannelItem {
  id: string;
  name: string;
  icon: string = "fas fa-question";
}

export class InvoiceTypes {
  id: string;
  name: string;
  value: string;
}

export class FormChannelContainer {
  list: Array<FormChannelItem>;
  new: FormChannelItem = new FormChannelItem();
}

export class FormChannelItem {
  id: string;
  formName: string;
  caseChannelId: string;
}

export class ActivityTypeContainer {
  list: Array<ActivityType>;
  new: ActivityType = new ActivityType();
  hide = false;
}

export class OfferRejectionContainer {
  list: Array<OfferRejection>;
  new = new OfferRejection();
}

export class OpsMaintenenceCategoriesContainer {
  private filterSet: Set<string> = new Set();
  private filterArray: Array<string>;
  private itemArray;
  list: Array<OpsMaintainCategory>;
  unusedTasks: Array<OpsMaintenanceTask>;
  tasks: Array<OpsMaintainItem>;
  subTasks: Array<OpsMaintainItem>;
  allTasks: Array<OpsMaintainItem>;
  taskIds: Array<string>;
  new = new OpsMaintenanceCategory();
  hide: boolean = true;
  tree: any;
  focusBranch: Array<OpsMaintainCategory>;
  focusCat: OpsMaintainCategory;
  focusItems: Array<OpsMaintainItem>;
  focusId: string;
  newCat: string = '';
  newItem = new OpsMaintainItem();
  deleteType: string;
  itemDragged;
  search: string = '';
  filter() {
    if (this.search != '') {
      // Reset on Search
      this.filterSet = new Set();
      // Filter on search
      // step 1. Find all tasks that contain filter string, aka filteredTasks
      let filteredSubTasks = this.filterSubTasksByString();
      let t = this.filterTasksByString(filteredSubTasks);
      let c = this.filterCatergoriesByString();
      let filteredTasks = t.map(x => x.id);
      // step 2. find all parent categories that has a filtered task , aka openCats, because they should be displayed as open
      let uniqueCatsWithTasks = Array.from(new Set(t.map(x => { return x.categoryId })));
      let openCats = this.findParentCategoriesById(uniqueCatsWithTasks);

      // step 3. remove all categories from filteredCats that are also in openCats, then filteredCats will known as closedCats
      //  openCats should display as open and should only contain those tasks that are filtered
      //  closedCats should display as closed and should contain all tasks that belong to the category
      // Find all children categories of categories that match search
      let closedSubs = this.list.filter(x => new Set(c).has(x.parentId)).map(x => { return x.id })
      closedSubs = this.findSubCategoriesById(closedSubs);
      let allCats = new Set(c.concat(openCats));
      let newList = this.list.filter(x => allCats.has(x.id));
      let cats = newList.map(x => {
        let filt = new Set(c).has(x.id) || new Set(closedSubs).has(x.id) ? this.tasks.filter(y => y.categoryId == x.id && filteredTasks.includes(x.id)) : t.filter(y => y.categoryId == x.id && filteredTasks.includes(x.id));
        return {
          name: x.name,
          id: x.id,
          parentId: x.parentId,
          showChildren: new Set(openCats).has(x.id),
          showItems: new Set(openCats).has(x.id),
          editing: false,
          hidden: filt.length > 0,
          items: t.filter(p => p.categoryId == x.id).map((y) => {
            return {
              categoryId: y.categoryId,
              id: y.id,
              data: y.data,
              selected: false,
              editing: false,
              hidden: false,
              hover: false,
              parentId: y.parentId,
              subAccounts: y.subAccounts
            }
          }),
          children: [],
          originalData: x,
          hover: false
        }
      });
      this.catToTree(cats, t, true)
    }
    else {
      this.catToTree(this.list, this.tasks, false);
    }
  }

  filterSubTasksByString() {
    const s = new RegExp(this.search, 'i');
    return this.subTasks.filter(x => 
      (x.data?.commonCost && s.exec(x.data.commonCost)) ||
      (x.data?.propertyCost && s.exec(x.data.propertyCost)) ||
      (x.data?.subscription && s.exec(x.data.subscription)) ||
      (x.data?.text && s.exec(x.data.text))
    );
  }

  filterTasksByString(sub: Array<OpsMaintainItem>) {
    const mappedSubs = sub.map(x => x.parentId);
    const s = new RegExp(this.search, 'i');
    return this.tasks.filter(x => 
      (x.data?.commonCost && s.exec(x.data.commonCost)) ||
      (x.data?.propertyCost && s.exec(x.data.propertyCost)) ||
      (x.data?.subscription && s.exec(x.data.subscription)) ||
      (x.data?.text && s.exec(x.data.text)) ||
      mappedSubs.includes(x.id)
    );
  }
  
  // getParentTasksFromSubTasks(t: Array<OpsMaintainItem>) {
  //   let subTasks = t.filter(x => this.taskIds.includes(x.parentId)).map(x => x.parentId);
  //   return {

  //   }
  // }

  filterCatergoriesByString() {
    let s = new RegExp(this.search, 'i');
    return this.list.filter(x => x?.name && s.exec(x.name)).map(x => { return x.id });
  }
  private findSubCategoriesById(l: Array<string>) {
    //console.log('Finding sub categories from ', l)
    let result = new Set(l), a;
    while (result.size > 0) {
      a = this.list.filter(x => result.has(x.parentId)).map(x => { return x.id });
      l = l.concat(a);
      //console.log('Found ', a, ' from', result)
      result = new Set(a)
    }
    return Array.from(new Set(l))
  }
  private findParentCategoriesById(l: Array<string>) {
    let result = new Set(l), a;
    while (result.size > 0) {
      a = this.list.filter(x => result.has(x.id)).map(x => { return x.parentId });
      a = a.filter(x => x != null);
      l = a.length > 0 ? l.concat(a) : l;
      result = new Set(a);
      result.delete(null);
    }
    return Array.from(new Set(l))
  }
  private findCategoryById(id) {
    this.filterSet.add(id);
    let f = this.list.find(x => x.id == id);
    if (f?.parentId) {
      //console.log('found category with parent', id, f.parentId)
      this.findCategoryById(f.parentId);
    }
  }
  catToTree(l: Array<OpsMaintainCategory>, t: Array<OpsMaintainItem>, filter) {
    let cats = l.map(x => {
      return {
        name: x.name,
        id: x.id,
        parentId: x.parentId,
        showChildren: x.showChildren,
        showItems: x.showItems,
        editing: false,
        hidden: false,
        hover: false,
        children: [],
        originalData: x,
        items: x.showChildren ? t.filter(y => y.categoryId == x.id).sort((a, b) => { return a.data.text.toLowerCase() > b.data.text.toLowerCase() ? 1 : -1 }) : this.tasks.filter(y => y.categoryId == x.id).sort((a, b) => { return a.data.text.toLowerCase() > b.data.text.toLowerCase() ? 1 : -1 })
      }
    }).sort((a, b) => a.name < b.name ? -1 : 1);
    this.unflatten(cats);
  }
  unflatten(arr) {
    let tree = [], mappedArr = {}, arrElem, mappedElem;
    // First map the nodes of the array to an object -> create a hash table.
    for (let i = 0, len = arr.length; i < len; i++) {
      arrElem = arr[i];
      mappedArr[arrElem.id] = arrElem;
      mappedArr[arrElem.id]['children'] = [];
    }
    for (let id in mappedArr) {
      if (mappedArr.hasOwnProperty(id)) {
        mappedElem = mappedArr[id];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.parentId) {
          try { mappedArr[mappedElem['parentId']]['children'].push(mappedElem); }
          catch (e) {
            // console.log(e, mappedArr, mappedElem)  
          }
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }
    this.tree = tree;
    if (!this.focusBranch) { this.refocusBranch(this.focusId) }
    this.flatten()
  }
  flatten() {
    this.itemArray = [];
    for (let x of this.tree) {
      this.extractChildren(x);
    }
  }
  extractChildren(c: OpsMaintainCategory) {
    if (!!c.items && c.items.length > 0) {
      this.itemArray = this.itemArray.concat(...c.items)
    }
    if (c.children && c.children.length > 0) {
      for (let x of c.children) {
        this.extractChildren(x)
      }
    }
  }
  refocusBranch(folderId: string) {
    this.focusId = folderId;
    this.focusCat = this.list.find(x => x.id == this.focusId);
    this.focusBranch = this.list.filter(x => x.parentId == this.focusId);
    this.focusItems = this.tasks.filter(x => x.categoryId == this.focusId);
    let a = this.list.find(x => x.id == folderId);
    if (!!a && !a.showChildren) {
      a.showChildren = true;
      a.showItems = true;
      this.catToTree(this.list, this.tasks, false);
    }
  }
  focusUpLevel() {
    this.refocusBranch(this.list.find(x => x.id == this.focusId).parentId);

  }
  mergeNewCats(data) {
    if (!this.list) {
      this.list = this.mapCats(data);
    }
    else {
      let set = this.list.map(x => { return x.id })
      let newFolders = this.mapCats(data.filter(x => !set.includes(x.id)));
      this.list = this.list.concat(newFolders).sort((a, b) => { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 });
      this.refresh();
    }
  }
  mapCats(data: Array<OpsMaintenanceCategory>): Array<OpsMaintainCategory> {
    return data.map(x => {
      return {
        id: x.id,
        parentId: x.parentId,
        name: x.name,
        items: [],
        children: [],
        showChildren: false,
        showItems: false,
        editing: false,
        hidden: false,
        hover: false,
        originalData: x
      }
    }).sort((a, b) => { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 })
  }
  deleteHide(folder: OpsMaintainCategory) {
    if (!folder) { return true }
    return this.list.filter(x => x.parentId == folder.id).length > 0 || this.tasks.filter(x => x.categoryId == folder.id).length > 0
  }
  refresh() {
    this.catToTree(this.list, this.tasks, this.search != '');
    this.refocusBranch(this.focusId);
  }
  getFolderNameById(id) {
    return this.list.find(x => x.id == id).name
  }
}

export class OpsMaintenanceCategory {
  id: string;
  name: string = '';
  parentId: string;
}

export class OpsMaintenanceTask {
  id: string | null = null;
  categoryId: string | null = null;
  propertyCost: string | null = null;
  subscription: string | null = null;
  commonCost: string | null = null;
  text: string = '';
  title: string = '';
  parentId: string | null = null;
  subAccount?: Array<OpsMaintenanceTask>;
}

export class OfferProcurementContainer {
  list: Array<OfferProcurement>;
  new = new OfferProcurement();
}

export class OfferEnterpriseContainer {
  list: Array<OfferEnterprise>;
  new = new OfferEnterprise();
}

export class OfferRejection {
  id: string;
  text: string = '';
}

export class OfferProcurement {
  id: string;
  name: string;
  icon: string = "fas fa-question";
}

export class OfferEnterprise {
  id: string;
  name: string;
  icon: string = "fas fa-question";
}

export class SkillsContainer {
  list!: Array<Skill>;
  new = new Skill();
}

export class DepartmentsContainer {
  list!: Array<Department>;
  new = new Department();
  hide = false;
}

export class StandardTextsContainer {
  list: Array<StandardText> = [];
  textList: Array<StandardText> = [];
  htmlList: Array<StandardText> = [];
  isSaving = false;
  new = new StandardText();
  toBeDeletedIndex: number | null = null;
  toBeDeletedType: string | null = null;
}

export class StandardText {
  category: string = '';
  content: string = '';
  header: string = '';
  inMessage: boolean = true;
  inOfferHTML: boolean = false;
  documentSpecific: string | null = null;
}

interface OpsMaintainCategory {
  name: string;
  id: string;
  parentId: string;
  showChildren: boolean;
  showItems: boolean;
  editing: boolean;
  hidden: boolean;
  items: Array<OpsMaintainItem>;
  children: Array<OpsMaintainCategory>;
  originalData: Object
}

export class OpsMaintainItem {
  categoryId: string | null = null;
  id: string | null = null;
  data: OpsMaintenanceTask = new OpsMaintenanceTask();
  selected: boolean | null = null;
  editing: boolean = false;
  hidden: boolean = false;
  parentId: string | null = null;
  hover?: boolean = false;
  subAccounts?: any;
}

export class CasePrioritiesContainer {
  list: Array<CasePriority> = [];
  new: CasePriority = new CasePriority();
}

export class CasePriority {
  priorityId: string | null = null;
  name: string = '';
  sortOrder: number = 0;
}

export class CaseStageContainer {
  list: Array<CaseStage> = [];
  new: CaseStage = new CaseStage();
}

export class CaseStage {
  stageId: string | null = null;
  name: string = '';
  sortOrder: number = 0;
  color: string = '#87ceeb';
  probability: number = 0;
}

export class CustomerTagsContainer {
  list: Array<CustomerTag> = [];
  new: CustomerTag = new CustomerTag()
}

export class CaseTagsContainer {
  list: CaseTag[] = [];
  new: { name: string, color: string } = { name: '', color: '' };
}

export class CaseTag {
  id: string | null = null;
  name: string = '';
  color: string = '';
}

export class CustomerTag {
  customerTagId?: string;
  name: string = '';
  color: string = '#87ceeb';
  sortOrder: number = 0;
}

export class AssetCategoriesContainer {
  list: IdName[] = [];
  new: IdName = new IdName();
}

export class AssetModels {
  id: string = '';
  name: string = '';
  model!: AssetModel;
  parents: Array<string> = [];
  isActive: boolean = true;
  type = new IdName();
  category = new IdName();
}

export class AssetModel {
  categoryId: string = '';
  categoryName: string = '';
  modelName: string = '';
  parents: Array<string> = [];
}